import Vue from 'vue';
import Vuex from 'vuex';
import { api } from "./api";
import Router from './../router';

Vue.use(Vuex);

import {actions} from './actions.js';
import {getters} from './getters.js';
import {mutations} from './mutations.js';


const state = {
  edit:false,
  singlpro:null,
  singlpics:null,
  kurs:null,
  kategorije:null,
  podkategorije:null,
  ppkategorije:null,
  pro:null,
  allpro:"",
  allpak:"",
  pak:"",
  pakname:"",
  savet:"",
  saveti:"",
  test:"",
  testiranja:"",
  sliketest:"",
  singlpk:null,
  opis:null,
  manufectur:false,
  brand:"",
  brandurl:process.env.API_PATH+"/brand?brandid=",
  katurl:process.env.API_PATH+"/kategorije?katid=",
  podkaturl:process.env.API_PATH+"/podkategorije?podkatid=",
  prourl:process.env.API_PATH+"/productimg?slid=",
  proprourl:process.env.API_PATH+"/productimg?proid=",
  testurl:process.env.API_PATH+"/sliketest?sltest=",
  saveturl:process.env.API_PATH+"/slikesavet?sltest=",
  propics:"",
  proname:"",
  // sid: window.localStorage.getItem('sid'),
  login:false,
  // search:false,
  terms:false,
  kat:true,
  naziv:"Pronađi svoj proizvod",
  pojedinacna:false,
  // policy:false,
  uslovi:false,
  prava:false,
  cart:[],
  // singlpro:[],
  // singl:"",
  total:0,
  subtotal:0,
  shipping:350,
  poruceno:false,
  // mlname:"",
  // categories:"",
  // lang:'srb',
  // error:"",
  // urlproduct:process.env.API_PATH+'/products?imgid=',

}
export const store = new Vuex.Store({
  strict:true,
  state,
  mutations,
  getters,
  actions
})



// WEBPACK FOOTER //
// ./src/vuex/store.js